import React from 'react'

import Node from './Node'

const FlowLog = props => {
	let { value } = props

	value ??= []

	return <div className='t-flowlog-wrap'>
		{value.map((log, index) => <Node key={index} log={log} prev={value[index - 1]} first={index === 0} last={index == value.length - 1} />)}
	</div >
}

export default FlowLog